import {
  availableCountry,
  availableLocale,
  countryLanguageMap,
  type Country,
  type Language,
  type Locale
} from './config-base';
import { mapLocaleToCountry } from '../../intl/utils/map-locale-to-country';
import { mapLocaleToLanguage } from '../../intl/utils/map-locale-to-language';

export {
  availableCountry,
  availableLocale,
  countryLanguageMap,
  type Country,
  type Language,
  type Locale
};

//TODO: vérifier dans l'url en changeant la langue si ca change les traductions
export const defaultLocale: Locale = `fr-BE`;
// export const defaultLocale: Locale = `en-GB`;

/**
 * Default country derived from default locale
 */
export const defaultCountry: Country = mapLocaleToCountry(defaultLocale);

export const defaultLanguage: Language = mapLocaleToLanguage(defaultLocale);
